import { createSlice } from "@reduxjs/toolkit";
import { defaultState } from "../../../../interfaces/auth";
import { changestatusResponsibilityThunk } from "../../../../asyncThunks/manage/setups";

const initialState: defaultState = {
    error: null,
    data: null,
    loading: false,
};

export const changestatusResponsibility = createSlice({

    name: "changestatusResponsibility",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(changestatusResponsibilityThunk.pending, (state, action) => {
            state.error = null;
            state.data = null;
            state.loading = true;
        });
        builder.addCase(changestatusResponsibilityThunk.fulfilled, (state, action) => {
            if (action?.payload?.status?.toLowerCase() === "success") {
                state.error = null;
                state.data = action.payload;
            } else {
                state.error = action?.payload;
                state.data = null;
            }
            state.loading = false;
        });
        builder.addCase(changestatusResponsibilityThunk.rejected, (state, action) => {
            state.error = action.payload;
            state.data = null;
            state.loading = false;
        });
    },
});

export default changestatusResponsibility.reducer;
